module.exports = __webpack_public_path__ + "static/media/BS_F_Embroidery_Bicocca_White_Bordeaux.c58e6270.png";